export default "__VITE_ASSET__3f0c4651__"